import {
  Box, Container, Wrap, Text,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';
import { useRef } from 'react';
import Pagination from '../../components/Pagination';
import PrintablePdf from '../../components/PrintablePdf';
import RoadNetworkUseReportHeader from './components/report-headers/RoadNetworkUseReportHeader';
import DataDisclaimer from '../../components/DataDisclaimer';
import RoadNetworkUseRoadUse from './components/report-sections/RoadNetworkUseRoadUse';
import RoadNetworkUseRestrictedBridges from './components/report-sections/RoadNetworkUseRestrictedBridges';
import RoadNetworkUseJourneyDistributionOnrc from './components/report-sections/RoadNetworkUseJourneyDistributionOnrc';
import RoadNetworkUseJourneyDistributionStreetCategory from './components/report-sections/RoadNetworkUseJourneyDistributionStreetCategory';
import RoadNetworkUseJourneyDistributionFreight from './components/report-sections/RoadNetworkUseJourneyDistributionFreight';
import RoadNetworkUseJourneyDistributionGeneralTraffic from './components/report-sections/RoadNetworkUseJourneyDistributionGeneralTraffic';
import RoadNetworkUseHeavyVehicleRoadUse from './components/report-sections/RoadNetworkUseHeavyVehicleRoadUse';

function RoadNetworkUse() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Road Network Use"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>
                This page provides information on total vehicle usage of the network and also usage by heavy vehicles such as trucks and buses.
              </Text>
              <Text mb={4}>
                Vehicle kilometres travelled (VKT) means the total number of kilometres that vehicles have travelled on roads in the network in the year.
              </Text>
              <Text>
                VKT is calculated from the latest traffic estimates for the roads in the network. Transport Insights provides a Traffic Count Estimation module for RCAs to calculate their traffic estimates.
              </Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <RoadNetworkUseReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper">
            <RoadNetworkUseRoadUse />
            <RoadNetworkUseHeavyVehicleRoadUse />
            <RoadNetworkUseRestrictedBridges />
            <RoadNetworkUseJourneyDistributionGeneralTraffic />
            <RoadNetworkUseJourneyDistributionFreight />
            <RoadNetworkUseJourneyDistributionStreetCategory />
            <RoadNetworkUseJourneyDistributionOnrc />
          </Wrap>
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default RoadNetworkUse;
